import campaignContactsActions from "actions/campaign_contacts";
import { Person, SearchBar, TableLoader } from "dyl-components"
import { useContext, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Checkbox, Grid, Icon, Pagination, Segment, Table } from "semantic-ui-react"
import { BulkActionsContext } from "shared/context/BulkActionsProvider";
import SelectAllCheckbox from "shared/SelectAllCheckbox";
import { PhoneUtil, StringUtils } from "utils";

const Recipients = ({textCampaignContactsCount, totalContactCount}) => {
    const [query, setQuery] = useState({
        search: '',
        page: 1
    });
    const { id } = useParams();

    const textCampaignContacts = useSelector(state => state.campaign_contacts.textCampaignContacts);
    const isReadingTextCampaignContacts = useSelector(state => state.campaign_contacts.isReadingTextCampaignContacts);
    const textCampaignContactIds = useSelector(state => state.campaign_contacts.textCampaignContactIds);
    const dispatch = useDispatch();
    const [selectedContacts, setSelectedContacts, areContactsInAllPagesSelected, setAreAllContactsInAllPagesSelected] = useContext(BulkActionsContext);

    const onFilter = (_, { name, value }) => {
        const isSearching = name === 'search' && value;
        const newQuery = isSearching ? { search: value } : { ...query, [name]: value, search: '' };
        setQuery(newQuery);
        dispatch(campaignContactsActions.readTextableContacts(id, newQuery));
        setAreAllContactsInAllPagesSelected(false);
    }

    
    const isSelected = (contact_id) => {
        return selectedContacts.includes(contact_id);
    };
    const onToggleContact = (contact_id) => {
        const newSelectedContacts = isSelected(contact_id)
            ? selectedContacts.filter((id) => contact_id !== id)
            : [...selectedContacts, contact_id];
        setSelectedContacts(newSelectedContacts);
    };

    return (
        <Grid as={Segment.Group} basic className="TextCampaignModal__recipients-section">
            <Grid.Row as={Segment} basic className="TextCampaignModal__recipients-search">
                <Grid.Column>
                    <SearchBar
                        search={query.search}
                        searchFcn={(value) => {
                            onFilter(null, {
                                name: 'search',
                                value
                            })
                        }}
                        cancelFcn={() => {
                            onFilter(null, {
                                name: 'search',
                                value: ''
                            })
                        }}
                        placeholder={'Search by name or number'}
                        shouldUnformatPhone
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row as={Segment} basic stretched>
                <Grid.Column stretched>
                    <div className="TextCampaignModal__recipients-list">
                        <Table basic='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1} className="TextCampaignModalRecipientList__cell">
                                        <SelectAllCheckbox 
                                            location="campaign" 
                                            count={textCampaignContactsCount} 
                                            data={textCampaignContacts} 
                                            idProperty={'id'} 
                                            type={textCampaignContactsCount > 1 ? 'contacts' : 'contact'} 
                                            isModal
                                            position="bottom left"
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width={9} className="TextCampaignModalRecipientList__cell">Recipients: {areContactsInAllPagesSelected ? textCampaignContactIds.length : selectedContacts.length} of {totalContactCount} contacts</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <div className="TextCampaignModal__recipients-header"></div>                            
                            <Table.Body>
                                {isReadingTextCampaignContacts ? (
                                    <TableLoader isLoading colspan={3} />
                                ) : textCampaignContacts.map(contact => {
                                    const contact_status = !contact.active ? 'inactive' : 'active';
                                    return (
                                        <Table.Row key={contact.id} disabled={!contact.active || contact.unlinked}>
                                            <Table.Cell width={1} className="TextCampaignModalRecipientList__cell">
                                                <Checkbox
                                                    onChange={() => onToggleContact(contact.id)}
                                                    checked={isSelected(contact.id)}
                                                    className="TextCampaignModalRecipientList__checkbox" />
                                            </Table.Cell>
                                            <Table.Cell className="TextCampaignModalRecipientList__cell">
                                                <Person
                                                    popup={false}
                                                    username={`${contact.first_name} ${contact.last_name}`}
                                                    email={PhoneUtil.formatPhoneNumber(contact.phone || '')}
                                                    link={<Link target="_blank" to={`/contact/${contact.id}`}>{`${contact.first_name} ${contact.last_name}`}</Link>} />
                                            </Table.Cell>
                                            <Table.Cell className={`TextCampaignModalRecipientList__cell ContactStatus__${contact_status}`}>
                                                <Icon
                                                    name="circle"
                                                    className={`ContactStatus__${contact_status}`} />
                                                {StringUtils.capitalize(contact_status)}
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                        </Table>
                    </div>    
                </Grid.Column>
            </Grid.Row>
            {textCampaignContactsCount > 0 && (
                <Grid.Row as={Segment}>
                    <Grid.Column textAlign="right">
                        <Pagination 
                            totalPages={Math.ceil(textCampaignContactsCount / 25)}
                            activePage={query.page}
                            onPageChange={(_, { activePage }) => onFilter(null, { name: 'page', value: activePage })}
                        />
                    </Grid.Column>
                </Grid.Row>
            )}
        </Grid>
    )
}

export default Recipients;
